import React from 'react';
import styles from './styles.css';
import loader from './loader.svg';

export default () => <div className='loading-page'><img src={loader} /><span>Carregando dados</span></div>;



// WEBPACK FOOTER //
// ./src/components/loading/LoadingPage.js